import previews from './previews';

export default previews;
